// Canonical object shapes for the sim's hottest per-day loops (perf). V8 gives objects built with different key
// orders — or parsed from JSON with different value types — different hidden classes; once a loop sees more than four
// (plots had 8–9 in a loaded 1990 save) every property access goes megamorphic, and the rival-wildcatter pass over
// ~1,560 plots a day cost ~0.5 ms. Building plots / rival leases / rival wells through these factories (new games,
// rival events, and every plot of a loaded save in migrate) keeps one shape each.
// Optional keys are present as `undefined`: JSON.stringify omits them, so saves look as before. No imports.

const PLOT_KEYS = ['x', 'y', 'seep', 'truth', 'pubEst', 'priceMult', 'owned', 'leaseDay', 'leaseExpires', 'survey', 'wellId', 'security',
  'taken', 'royalty', 'leasePaid', 'licence', 'seized', 'roundWon'];
const PLOT_SET = new Set(PLOT_KEYS);
export function makePlot(p) {
  const o = {
    x: p.x, y: p.y, seep: p.seep, truth: p.truth, pubEst: p.pubEst, priceMult: p.priceMult, owned: p.owned, leaseDay: p.leaseDay,
    leaseExpires: p.leaseExpires, survey: p.survey, wellId: p.wellId, security: p.security,
    taken: p.taken == null ? p.taken : makeTaken(p.taken), royalty: p.royalty, leasePaid: p.leasePaid, licence: p.licence, seized: p.seized, roundWon: p.roundWon,
  };
  for (const k in p) if (!PLOT_SET.has(k)) o[k] = p[k]; // anything newer keeps working (appended)
  return o;
}

const TAKEN_SET = new Set(['by', 'day', 'drillDay', 'well', 'offset', 'roundWon']);
export function makeTaken(t) {
  const o = { by: t.by, day: t.day, drillDay: t.drillDay, well: t.well == null ? t.well : makeRivalWell(t.well), offset: t.offset, roundWon: t.roundWon };
  for (const k in t) if (!TAKEN_SET.has(k)) o[k] = t[k];
  return o;
}

const WELL_SET = new Set(['resId', 'qi', 'startDay', 'di', 'b', 'dry']);
// A rival well: producing { resId, qi, startDay, di, b } or dry { dry: true } — one shape for both.
export function makeRivalWell(w) {
  const o = { resId: w.resId, qi: w.qi, startDay: w.startDay, di: w.di, b: w.b, dry: w.dry };
  for (const k in w) if (!WELL_SET.has(k)) o[k] = w[k];
  return o;
}

// Every plot of every field through makePlot (load path: core/save.migrate). Idempotent; JSON unchanged.
export function normalizePlots(state) {
  for (const f of Object.values(state.fields ?? {})) if (Array.isArray(f.plots)) f.plots = f.plots.map(makePlot);
}
